import { render } from "./textBlock.vue?vue&type=template&id=12d711c6&ts=true"
import script from "./textBlock.vue?vue&type=script&lang=ts"
export * from "./textBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__